module.exports = __webpack_public_path__ + "img/game_main_pc_223_off.9f611ec0.png";